<template>
    <div>
        <div class="title">
            使用模板-导入待面试表

        </div>
        <div>
            <Spin fix v-if="loading"></Spin>
            <div class="title_detail">
                <a :href="import_template_url" class="" style="color:#0466dd">
                    <Icon type="md-cloud-download" style="margin-right:5px" />点击下载导入模板
                </a>
                <!-- <a target="_black" :href="video_url" style="margin-left:30px;color:#0466dd">
                <Icon style="margin-right:5px" type="logo-youtube" />观看导入视频教程
            </a> -->
            </div>
            <div class="source_table">
                <TablePaste hide-table :input-props="inputProps" @on-success="handleSuccess" @on-error="handleError" />
            </div>
            <div class="source_table">
                <Table size="small" :height="windowHeight - 330" :columns="columns" :data="table_data" border></Table>
            </div>
            <div class="import_button">
                <Button type="primary" @click="templaet_add" :loading="loading">
                    <Icon style="margin-right:5px" type="ios-add-circle-outline" />开始导入
                </Button>
            </div>
        </div>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {

    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            inputProps: {
                rows: 6,
                placeholder: '使用说明：不用上传文件，打开表格，复制表格数据粘贴到此处'
            },
            columns: [],
            table_data: [],
            import_template_url: '',
            video_url: '',
            project_id: '',
            shift_id: "",
            loading: false
        }
    },
    mounted() {
        var query = this.$route.query
        this.project_id = query.project_id
        this.shift_id = query.shift_id

        this.get_import_template()
        this.window_change()
    },
    methods: {
        //模板添加
        templaet_add() {
            console.log(this.table_data)
            if (!this.project_id) {
                this.$Message.error('没有项目id')
                return
            }
            if (!this.shift_id) {
                this.$Message.error('没有shift,id')
                return
            }
            var that = this
            var obj = {
                table_data: this.table_data,
                project_id: this.project_id,
                shift_id: this.shift_id
            }
            this.loading = true
            http("post", process.env.VUE_APP_HOST + "/daily/add_people_batch", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.loading = false

                }
            ).catch((res) => {
                that.loading = false

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        },
        get_import_template() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/daily/batch_template", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.import_template_url = res.data.url

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },
        handleSuccess(tableData) {
            console.log(tableData);
            this.columns = tableData.columns;
            this.table_data = tableData.data;
        },
        handleError(tableData, errorIndex) {
            console.log(tableData, errorIndex);
            this.$Message.error('表格数据有误');
        }
    }
}
</script>

<style scoped>
.import_button {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
}

.title_detail {
    padding: 10px 15px;
}

.source_table {
    padding: 10px;
}

.title {
    font-size: 16px;
    font-weight: 600;
    color: #0466dd;
    text-align: center;
    padding: 10px;
}
</style>